import { Box, Card } from "@mui/material"
import { useTheme } from "@mui/styles"

const LicenseCard = ({ borderColor, children, hoverable = false, selected = false }) => {
    const theme = useTheme()
    const hoverColor = theme.palette.license.subscription

    return (
        <Card
            tabIndex={hoverable ? 0 : -1}
            sx={{
                borderRadius: "16px",
                textAlign: "left",
                borderTop: "none",
                height: "100%",
                position: "relative",
                boxShadow: (theme) => theme.customShadows.lighterDialog,
                outline: selected ? `5px solid ${hoverColor}` : "none",
                outlineOffset: selected ? "-5px" : "none",
                ...(hoverable && {
                    cursor: "pointer",
                    "&:hover, &:focus-within": {
                        outline: `3px solid ${hoverColor}`,
                        outlineOffset: "-3px",
                        boxShadow: "0 8px 32px 0 rgba(56,147,155,0.12)",
                        backgroundColor: theme.palette.action.hover,
                    },
                }),
            }}
        >
            <div
                style={{
                    backgroundColor: borderColor,
                    borderRadius: "16px 16px 0px 0px",
                    height: "14px",
                    position: "relative",
                    width: "100%",
                }}
            />
            <Box
                sx={{
                    p: 3,
                }}
            >
                {children}
            </Box>
        </Card>
    )
}

export default LicenseCard
